import { render, staticRenderFns } from "./MessageRevisionsTable.vue?vue&type=template&id=c36dcf84&scoped=true&"
import script from "./MessageRevisionsTable.vue?vue&type=script&lang=js&"
export * from "./MessageRevisionsTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageRevisionsTable.vue?vue&type=style&index=0&id=c36dcf84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36dcf84",
  null
  
)

export default component.exports